import React from 'react'; 
// import parser from 'html-react-parser';
import '../../../CSS/about.scss';

const AboutContent = ({data,contenttype})=> { 
  return (
    <div className="life-hashtags">
      <div className="container">
          <div>
                <div className="row">
              <div className="col-md-4 col-lg-4"></div>
              <div className="col-md-4 col-lg-4">
                  <h4 className="header_or_link">{data.title}</h4>
              </div>
              <div className="col-md-4 col-lg-4"></div>
          </div>
          <div className="row">
              <div className="col-md-2 col-lg-2"></div>
              <div style={{padding: "15px"}} className="col-md-8 col-lg-8">
                {data.contents && (contenttype === 'tag')? 
                data.contents.map((value,index)=>{
                  return (<span className="contentTag" key={index}>#{value} </span>)
                }) : 
                data.contents.map((value,index)=>{
                  if(Number(index) === 0) return (<span className="contentTag" key={index}>{value} </span>);
                  else return (<span className="contentTag" key={index}>/ {value} </span>);
                }) 
              }
              </div>
              <div className="col-md-2 col-lg-2"></div>
          </div>
              </div>
      </div>
    </div>
  );
}

export default AboutContent; 